import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { OverlayModule } from '@angular/cdk/overlay';
import { MrsBtnIconComponent, MrsBtnOutlineComponent, MrsBtnPrimaryComponent, MrsBtnTertiaryComponent, MrsTreeviewComponent } from './components';
import { BannerComponent } from './components/banner/banner.component';
import { AutoSuggestComponent } from '@Components/form-fields/auto-suggest/auto-suggest.component';
import { RemoveHtmlTagsPipe } from '@Pipes/removehtmltags.pipe';
import { DisplayLabelValueComponent } from '@Components/display-label-value/display-label-value.component';

@NgModule({
    declarations: [],
    imports: [MrsBtnIconComponent, MrsBtnOutlineComponent, MrsBtnPrimaryComponent, MrsBtnTertiaryComponent,
        AutoSuggestComponent, MrsTreeviewComponent,
        RemoveHtmlTagsPipe,
        DisplayLabelValueComponent,
        BannerComponent
    ],
    exports: [
        CommonModule,
        MatButtonModule,
        MatInputModule,
        MatToolbarModule,
        MatSidenavModule,
        MatCardModule,
        MatRadioModule,
        MatListModule,
        MatTabsModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatTreeModule,
        MatStepperModule,
        MatChipsModule,
        MatSortModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatTableModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        RxReactiveFormsModule,
        ScrollingModule,
        OverlayModule,
        MrsBtnIconComponent, MrsBtnOutlineComponent, MrsBtnPrimaryComponent, MrsBtnTertiaryComponent,
        AutoSuggestComponent,
        RemoveHtmlTagsPipe,     
        MrsTreeviewComponent,
        DisplayLabelValueComponent,
        BannerComponent
    ]
})
export class SharedModule {
}
